/**
 * mw-amazon-lightbox.js — Alpine component for the Amazon reviews lightbox.
 *
 * Section markup uses x-data="mwAmzLightbox". This file registers that
 * component via alpine:init so it's available before Alpine evaluates
 * the attribute. Same pattern as the other MW factories; without it
 * Alpine resolves `open` against window.open (truthy → lightbox opens
 * on load).
 */
document.addEventListener('alpine:init', function () {
  if (!window.Alpine) return;
  window.Alpine.data('mwAmzLightbox', function () {
    return {
      open: false,
      index: 0,
      images: [],
      imageCount: 0,

      initImages: function (stripEl) {
        if (!stripEl) return;
        var imgs = stripEl.querySelectorAll('.amz__card img');
        this.images = Array.from(imgs).map(function (img) {
          var srcset = img.getAttribute('srcset') || '';
          var candidates = srcset.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          var last = candidates[candidates.length - 1];
          var big = last ? last.split(' ')[0] : img.src;
          return big || img.src;
        });
        this.imageCount = this.images.length;
      },

      get currentSrc() {
        return this.images[this.index] || '';
      },

      openAt: function (i) {
        if (i < 0 || i >= this.imageCount) return;
        this.index = i;
        this.open = true;
        document.body.style.overflow = 'hidden';
      },

      close: function () {
        this.open = false;
        document.body.style.overflow = '';
      },

      next: function () {
        if (this.index < this.imageCount - 1) this.index += 1;
      },

      prev: function () {
        if (this.index > 0) this.index -= 1;
      }
    };
  });
});

// Keyboard navigation while the lightbox is open — runs independent of Alpine.
window.addEventListener('keydown', function (e) {
  var root = document.querySelector('.amz-lightbox.is-open');
  if (!root) return;
  var section = root.closest('.amz');
  if (!section || !section._x_dataStack) return;
  var data = section._x_dataStack[0];
  if (!data) return;
  if (e.key === 'ArrowLeft' && typeof data.prev === 'function') data.prev();
  if (e.key === 'ArrowRight' && typeof data.next === 'function') data.next();
});
